import axios from '@_system/axios/axios.js'
export default {
	path: '/staff',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	getdetail(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/getdetail/' + id, data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path+'/' + id, data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path+'/' + id, data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	resetpassword(id,data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path+'/resetpassword/'+id, data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},	
	
	getStaffConfig(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getStaffConfig', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	setStaffConfig(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/setStaffConfig', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	delStaffConfig(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/delStaffConfig', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	init(data = {}) {
		return new Promise((resolve, reject) => {
			axios.get('moduleConfig/'+window.config.app+'/system.staff', data, (res) => {
				resolve(res.data)
			}, reject, true)
		})
	}	
	// init(data = {}) {
	// 	return new Promise((resolve,reject) => {
	// 		axios.get('moduleConfig/system/staff', data, (res) => {
	// 			resolve(res.data)
	// 		},reject,true)
	// 	})
	// },
}
